/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1OrderLineStatus } from '../models/V1OrderLineStatus';
import { V1State } from '../models/V1State';
import { HttpFile } from '../http/http';

/**
* OrderLineUnarchived is an event that is produced by the order_line service, after the order_line has been successfully un archived.
*/
export class V1OrderLineUnarchived {
    'orderLineId'?: string;
    'requestId'?: string;
    'userId'?: string;
    'orgId'?: string;
    'timestamp'?: Date;
    'status'?: V1OrderLineStatus;
    'state'?: V1State;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orderLineId",
            "baseName": "order_line_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "requestId",
            "baseName": "request_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "userId",
            "baseName": "user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "V1OrderLineStatus",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "V1State",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1OrderLineUnarchived.attributeTypeMap;
    }

    public constructor() {
    }
}

